import { defineStore } from 'pinia'
import findIndex from 'lodash/findIndex'

const state = () => ({
  bookmarks: [],
})

// functionName: (state, getters, rootState) => {}
const getters = {
}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  isBookmarked(item) {
    return findIndex(this.bookmarks, { id: item.id, type: item.type }) !== -1
  },
  addBookmark(item) {
    this.bookmarks.push(item)
  },
  removeBookmark(item) {
    const index = findIndex(this.bookmarks, { id: item.id, type: item.type })
    if (index !== -1) {
      this.bookmarks.splice(index, 1)
    }
  }
}

export default defineStore({
  id: 'bcBookmark',
  state,
  getters,
  actions
})
